export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-checkbox-14ca02d66a4c4702754519de768cdd5b.svg";